module.exports = __webpack_public_path__ + "img/prius-prime-20.10d16394.jpg";